
//          let uri = `/api/protected/cfop/pesquisar?id=${id}&natureza=${natureza}`

import axios from "axios";

export default {
  namespaced: true,
    state: {
        lista: [],
        perPage: 100,
        id: null,
        nome: null,
        registroSelecionadoId: null,
        paginaAtual: 1,
    },
    getters: {
      LISTA: state => {
          return state.lista
      },
      PER_PAGE: state => { 
          return state.perPage
      },
      ID: state => { 
          return state.id
      },
      NOME: state => { 
          return state.nome
      },
      REGISTRO_SELECIONADO_ID: state => {
          return state.registroSelecionadoId
      },
      PAGINA_ATUAL: state => {
          return state.paginaAtual
      }
    },
    /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
    mutations: {
      SET_LISTA: (state, payload) => {
          state.lista = payload
      },
      SET_PER_PAGE: (state, payload) => {
          state.perPage = payload
      },
      SET_ID: (state, payload) => {
          state.id = payload
      },
      SET_NOME: (state, payload) => {
          state.nome = payload
      },
      SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
          state.registroSelecionadoId = payload
      },
      SET_PAGINA_ATUAL: (state, payload) => {
          state.paginaAtual = payload
      },
      SET_LIMPAR: (state, payload) => {
        state.lista = [],
        state.id = null,
        state.nome = null,
        state.registroSelecionadoId = null
        state.paginaAtual = 1
      },
      SET_LIMPAR_APENAS_FILTRO: (state, payload) => {
          state.filtroAvancado = false,
          state.lista = [],
          state.paginaAtual = 1
      }
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GET_LISTA: ({ commit, getters }) => {
      return new Promise((resolve, reject) => {
            // Monte um objeto com todos os possíveis filtros
        const filtros = {
            id: getters.ID ?? null,
            nome: getters.NOME ?? null
        }

        axios.post(`/api/protected/departamento/pesquisar`, filtros)
        .then(({ data, status }) => {
            commit("SET_LISTA", data);
            if (status === 200 || status === 201) {
                resolve({ data, status });
            }
        })
        .catch(error => {
          reject(error)
        })
      })
    }
  }
}          


// WEBPACK FOOTER //
// ./src/vuex/modulos/departamento-store.js